import axios from 'axios';
import { backendURL } from '../App';
import { useQuery } from 'react-query';

const getUserData = async _ => {
  const { data } = await axios({
    method: 'get',
    url: `${backendURL}user/${localStorage.getItem('skillsSurveyUserID')}/`,
    headers: {
      Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
    },
  });
  return data;
};

export default function useUserData() {
  return useQuery(['userData'], getUserData, {
    // См. комментарий в useClientAnketaData — конечный retry нужен чтобы react-query
    // выставил .error и ErrorInfiniteRetry смог отличить network от HTTP-ошибки.
    retry: 3,
    retryDelay: (attempt: number) => Math.min((attempt + 1) * 500, 3000),
    refetchOnWindowFocus: false,
    enabled: localStorage.getItem('skillsSurveyUserID'),
  });
}
